import { useEffect, useRef, useState } from "react";
import AccountMail from "~/assets/icons/AccountMail";
import AccountName from "~/assets/icons/AccountName";
import AccountPhone from "~/assets/icons/AccountPhone";
import StoreIcons from "~/assets/icons/StoreIcons";
import { contactForm, contactInfo, retailSystem, showCaptcha, storeCredentials } from "../../setup/settings/index";
import HCaptcha from '@hcaptcha/react-hcaptcha';

export default function ContactForm() {
    const [token, setToken] = useState(null);
    const captchaRef = useRef(null);

    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        storename: '',
        destinationEmail: contactInfo.mailTo,
        storeDomain: storeCredentials.storeDomain
    })

    const [loading, setLoading] = useState(false)
    const [hasSubmitSuccess, setHasSubmitSuccess] = useState(false)
    const [hasSubmitError, setHasSubmitError] = useState(false)

    const onChange = (event) => {
        setForm(old => ({ ...old, [event.target.id]: event.target.value }))
    }

    const onSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        if(showCaptcha.visible){
            if (token) {
                await sendMail();
                setToken(null);
                resetCaptcha();
            } else {
                setHasSubmitError(true);
                setLoading(false)
            }
        }else{
            await sendMail();
        }
        
    }

    const resetCaptcha =()=>{
        captchaRef.current.resetCaptcha();
    }

    const onExpire = () => {
        console.log("hCaptcha Token Expired");
    };

    const onError = (err) => {
        console.log(`hCaptcha Error: ${err}`);
    };

    const emptyInputForm = () => {
        setForm({
            name: '',
            email: '',
            phone: '',
            storename: '',
            message: '',
            destinationEmail: contactInfo.mailTo,
            storeDomain: storeCredentials.storeDomain
        })
    }


    useEffect(() => {
        if (hasSubmitError) {
            setTimeout(() => {
                setHasSubmitError(false);
            }, 5000);
        }
    }, [hasSubmitSuccess]);

    useEffect(() => {
        if (hasSubmitSuccess) {
            setTimeout(() => {
                setHasSubmitSuccess(false);
            }, 5000);
        }
    }, [hasSubmitSuccess]);


    const sendMail = async () => {
        const response = await callSendEmail(form);
        if (response.error) {
            setLoading(false)
            setHasSubmitError(false)
        } else {
            setLoading(false)
            setHasSubmitSuccess(true)
            emptyInputForm()
        }
    }

    return (
        <div className="contactPage__contactForm">
            <div className="formContainer">
                <form className="customForm" onSubmit={onSubmit}>
                    {contactForm.fields.name.showInput &&
                        <div className="nameIcon"><AccountName />
                            <input value={form.name} onChange={onChange} required={contactForm.fields.name.required}
                                autoComplete='name' type="name" id="name" placeholder={`Name${contactForm.fields.phone.required ? "*" : ""}`}></input>
                        </div>
                    }
                    {contactForm.fields.email.showInput &&
                        <div className="emailIcon"><AccountMail />
                            <input value={form.email} onChange={onChange} required={contactForm.fields.email.required}
                                autoComplete='email' type="email" id="email" placeholder={`Email${contactForm.fields.email.required ? "*" : ""}`}></input>
                        </div>
                    }
                    {contactForm.fields.phone.showInput &&
                        <div className="phoneIcon"><AccountPhone />
                            <input value={form.phone} onChange={onChange} required={contactForm.fields.phone.required}
                                autoComplete='tel' type="tel" id="phone" placeholder={`Phone${contactForm.fields.phone.required ? "*" : ""}`}></input>
                        </div>
                    }
                    {contactForm.fields.storeName.showInput &&
                        <div className="storeName"><StoreIcons />
                            <input value={form.storename} onChange={onChange} required={contactForm.fields.storeName.required}
                                autoComplete='storename' type="text" id="storename" placeholder={`Store name${contactForm.fields.storeName.required ? "*" : ""}`}></input>
                        </div>
                    }
                    {contactForm.fields.message.showInput &&
                        <>
                            <label>Your Message</label>
                            <textarea value={form.message} onChange={onChange} required={contactForm.fields.message.required}
                                id="message" autoComplete='message' ></textarea>
                        </>
                    }
                    <br></br>
                    {showCaptcha.visible &&
                        <HCaptcha
                            sitekey= {showCaptcha.sitekey}
                            onVerify={setToken}
                            onError={onError}
                            onExpire={onExpire}
                            ref={captchaRef}
                            languageOverride= {showCaptcha.language}
                        />
                    }
                    <input type="submit" value={loading ? 'Loading' : 'Submit'} ></input>
                    {hasSubmitSuccess && <p className="text-green-500">Your message was sent successfully.</p>}
                    {hasSubmitError && <p className="text-red-500">Sorry, the request could not be sent. Please try again.</p>}
                </form>
            </div>
        </div>
    )
}

const callSendEmail = async (form) => {
    try {
        const bodyRequest = JSON.stringify(form)
        const res = await fetch(`${retailSystem.sendContactFormEmail}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Shopify-Store-Domain': `${storeCredentials.storeDomain}`
            },
            body: bodyRequest,
        });
        if (res.ok) {
            return {};
        } else {
            return res.json();
        }
    } catch (error: any) {
        return {
            error: error.toString(),
        };
    }
}